import { TableHeader, TableHeaderDefs, TableHeaderDefsRow } from '../../types';
import { GroupContext } from './group-context';

export class TableHeaderDefsBuilder {
  private groupContext: GroupContext;
  private hiddenColumns: Set<number>;

  public init(context: GroupContext, hiddenColumns: Set<number>): void {
    this.groupContext = context;
    this.hiddenColumns = hiddenColumns;
  }

  public buildTableHeaderDefs(headerLabels: string[]): TableHeaderDefs {
    const firstRow: TableHeaderDefsRow = headerLabels
      .map(this.labelToTableHeader)
      .filter(this.isColumnVisible)
      .filter(this.isUngroupedColumnOrGroupPrimary);

    const headerDefs: TableHeaderDefs = [firstRow];

    for (let rowIndex = 0; rowIndex < this.groupContext.biggestGroupSize - 1; rowIndex++) {
      const rowDef: TableHeaderDefsRow = [];
      headerDefs.push(rowDef);

      for (const header of firstRow) {
        const group = this.groupContext.columnGroupsByPrimaryColumn.get(header.column);

        if (!group) {
          rowDef.push(null);
          continue;
        }

        const rowHasContentInColumn = rowIndex < group.secondaryColumns.length;
        const headerColumnIndex = rowHasContentInColumn ? group.secondaryColumns[rowIndex] : null;
        const headerDef: TableHeader = headerColumnIndex !== null ? { label: headerLabels[headerColumnIndex], column: headerColumnIndex } : null;

        rowDef.push(headerDef);
      }
    }

    return headerDefs;
  }

  private labelToTableHeader(label: string, column: number): TableHeader {
    return { column, label };
  }

  private readonly isColumnVisible = (header: TableHeader): boolean => {
    return !this.hiddenColumns.has(header.column);
  };

  private readonly isUngroupedColumnOrGroupPrimary = (header: TableHeader): boolean => {
    return this.groupContext.groupedColumns.has(header.column)
      ? this.groupContext.columnGroupsByPrimaryColumn.has(header.column)
      : true;
  };
}
